<main>
  <div class="app-pre-loader" *ngIf="areTranslationsLoading">
    Loading<span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>
  <div id="root" [ngStyle]="{
    'color': getTextColor(),
    'background-color': '#f4f4f4',
    'font-family': getFont() + ', sans-serif'
    }">
    <app-loader *ngIf="areTranslationsLoading"></app-loader>
    <app-navbar *ngIf="!areTranslationsLoading"></app-navbar>
    <router-outlet *ngIf="!areTranslationsLoading"></router-outlet>
    <chapps-request-error-modal></chapps-request-error-modal>
    <app-photo-viewer></app-photo-viewer>
  </div>
</main>


